/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ApiCredentials { 
    id: string;
    username?: string;
    apikey?: string;
    token?: string;
    expiration?: Date;
    grantType?: string;
    principal?: string;
    password?: string;
    email?: string;
    dateCreated?: Date;
    creatorId?: string;
    description?: string;
    smsRouteName?: string;
}
